Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.useNativeDriver = void 0;
var _reactNative = require("react-native-web");
var useNativeDriver = exports.useNativeDriver = _reactNative.Platform.OS !== 'web' ? true : false;